import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { edgeTypeMatrix } from '@iotv/datamodel';
import { BranchingQueryDefinition, getNestedStructureBranchingQuery } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType, LogicalOperatorType, Traversal } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import { MenuItem, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { genericListViewDefinition } from '../../../../components/factories/AttributeDefinitions';
import { ObjectViewType } from '../../../../types';
import { ListerlizerAdapter } from '../../../factories/Listerlizer/legacy/ListerlizerAdapter';
const userToAllUserGroups = getNestedStructureBranchingQuery({
    groupObjectType: 'Group',
    containedObjectType: 'User',
    traversal: Traversal.ASCENDING,
    includeSupportedTypeInstances: false,
});
const UserToUserGroupType = new BranchingQueryDefinition({
    id: 'UserToUserGroupType',
    path: [
        {
            adjacencyType: AdjacentType.PARENT,
            objectTypeId: 'Group',
            edgeTypeId: edgeTypeMatrix.Group.User.group_has_user.edgeTypeId,
            nodeFilters: [{ setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'User' }] }],
        },
    ],
    subQueries: [],
});
const otherGroupSupportedType = 'Silo';
const UserGroupsToOtherGroupType = new BranchingQueryDefinition({
    id: 'UserGroupsToOtherGroupType',
    path: [
        {
            adjacencyType: AdjacentType.CHILD,
            objectTypeId: 'Group',
            edgeTypeId: edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId,
            nodeFilters: [
                {
                    setOperation: LogicalOperatorType.AND,
                    filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: otherGroupSupportedType }],
                },
            ],
        },
    ],
    subQueries: [],
});
const OtherGroupDescendingHierarchy = getNestedStructureBranchingQuery({
    groupObjectType: 'Group',
    containedObjectType: otherGroupSupportedType,
    traversal: Traversal.DESCENDING,
    includeSupportedTypeInstances: false,
});
export const IndirectInference = ({ value }) => {
    const [{ applicationData, contextUser, TransactionFunctions: transactionFunctions, UserFunctions: userFunctions }] = useContext(AppMainViewContext);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(undefined);
    const [viewObject, setViewObject] = useState({ matchedPrimary: undefined, matchedRelatedByPk: [], matchedRelatedBySk: [] });
    useEffect(() => {
        if (applicationData) {
            setUsers(applicationData.getNodesOfType('User'));
        }
    }, [applicationData]);
    useEffect(() => {
        if (selectedUser && applicationData) {
            const userGroupsRes = applicationData?.applyBranchingQuery([selectedUser], UserToUserGroupType);
            const userGroups = userGroupsRes.getNodesOfType('Group');
            const ascendantGroupsRes = applicationData?.applyBranchingQuery(userGroups, userToAllUserGroups);
            const ascendantGroups = ascendantGroupsRes.getNodesOfType('Group');
            const allowedGroupsRes = applicationData?.applyBranchingQuery(ascendantGroups, UserGroupsToOtherGroupType);
            const allowedGroups = allowedGroupsRes.getNodesOfType('Group').filter((n) => n.supportedType === otherGroupSupportedType);
            const descendingGroupsRes = applicationData?.applyBranchingQuery(allowedGroups, OtherGroupDescendingHierarchy);
            const descendingGroups = descendingGroupsRes.getNodesOfType('Group').filter((n) => n.supportedType === otherGroupSupportedType);
            console.log({
                applicationData,
                userGroups,
                ascendantGroupsRes,
                ascendantGroups,
                allowedGroups,
                descendingGroups,
            });
            setViewObject({ matchedPrimary: contextUser, matchedRelatedByPk: [], matchedRelatedBySk: descendingGroups });
        }
    }, [selectedUser?.sk, applicationData]);
    const adjacentFilter = { adjacentType: AdjacentType.CHILD, objectType: otherGroupSupportedType };
    const listerlizerProps = {
        autoQuery: false,
        adjacentFilter: { adjacentType: AdjacentType.CHILD, objectType: otherGroupSupportedType },
        columnVisibilityReferences: { dataTableReference: 'slot3Indirect', objectTypeId: otherGroupSupportedType, viewType: ObjectViewType.List },
        contextObject: selectedUser,
        searchRootObject: undefined,
        transactionFunctions,
        userFunctions,
        viewDefinition: genericListViewDefinition,
        viewObject,
    };
    return (_jsx(TabPanel, { value, children: _jsxs("div", { children: [_jsxs("div", { children: [" ", applicationData && JSON.stringify(viewObject, null, 1)] }), _jsx(Typography, { variant: 'h6', children: "Infer visible Device Groups" }), _jsx(TextField, { select: true,
                    value: selectedUser?.sk,
                    onChange: (e) => {
                        setSelectedUser(users.find((user) => user.sk === e.target.value));
                    }, children: users.map((user) => (_jsx(MenuItem, { value: user.sk, children: user.name }, user.sk))) }), _jsx(ListerlizerAdapter, { ...listerlizerProps })] }) }, 'tableQueryFilter'));
};
